import { Container, Text } from "@simplybusiness/mobius";
import { numberToWord } from "../../utils/numberToWord";
import type { QuoteHeadlineProps } from "./types";

export const QuoteHeadline = ({
  quoteCount,
  customerName,
  trade,
  verticalHeadlineWording,
}: QuoteHeadlineProps) => {
  if (quoteCount === 0) {
    return (
      <div className="mobius-quote-headline__no-quotes-title">
        <strong>Edit your limits and covers</strong>
      </div>
    );
  }

  const highlightClasses = "mobius-quote-headline__highlight";

  return (
    <Container size="sm">
      <Text
        className="mobius-quote-headline__text"
        style={{ color: "var(--color-text-lead)" }}
      >
        Thanks{" "}
        <span className={highlightClasses}>
          <strong className="has-pii">{customerName}</strong>
        </span>
        , we&apos;ve searched through our trusted panel of insurers and found{" "}
        <span className={highlightClasses}>
          <strong>{numberToWord(quoteCount)}</strong>
        </span>{" "}
        provider{quoteCount > 1 ? "s" : ""} who can give you a quote for your{" "}
        <span className={highlightClasses}>
          <strong>{trade}</strong>
        </span>
        {verticalHeadlineWording ? " " + verticalHeadlineWording + "." : "."}
      </Text>
    </Container>
  );
};
